import httpClient from '../httpClient';

// 사용자 목록 조회 (필터 param: cardCd, dateFR, dateTO)
export const login = async (id, password) => {
  const result = await httpClient.post('/customer/login', {
    userId: id,
    password: password,
  });
  return result.data;
};

export const changePassword = async (idCustomer, cpassword, npassword) => {
  const result = await httpClient.post('/customer/change-password', {
    idCustomer: idCustomer,
    cpassword: cpassword,
    npassword: npassword,
  });
  return result.data;
};

export const setCustomer = async (idCustomer, customerInfo) => {
  const result = await httpClient.post('/customer/set', {
    idCustomer: idCustomer,
    customerInfo: customerInfo,
  });
  return result.data;
};

export const registerCustomer = async (customerInfo) => {
  const result = await httpClient.post('/customer/register', {
    customerInfo: customerInfo,
  });
  return result.data;
};

export const registerCS = async (csInfo) => {
  const result = await httpClient.post('/customer/register-cs', csInfo);
  return result.data;
};

// Request password reset link
export const requestPasswordReset = async (email) => {
  const result = await httpClient.post('/customer/request-password-reset', {
    email: email,
  });
  return result.data;
};

// Reset password with token
export const resetPassword = async (token, newPassword, email = '') => {
  const result = await httpClient.post('/customer/reset-password', {
    token: token,
    newPassword: newPassword,
    email: email,
  });
  return result.data;
};

export const getCustomerProfile = async (idCustomer) => {
  const result = await httpClient.get('/customer/profile', {
    params: {
      idCustomer: idCustomer,
    },
  });
  return result.data;
};

export const getEmployees = async () => {
  const result = await httpClient.get('/customer/employees');
  return result.data;
};
